import React from 'react';
import styles from './MissingValue.module.scss';

const MissingValue = (): JSX.Element => <span className={styles.value}>&mdash;</span>;

export default MissingValue;
